module.exports = "<section  class=\"sequencer_node_inpestor_details\">\n<section class=\"params_list\">\n</section>\n</section>"